import React from "react";
import "./Card.css";
import { Typography, Card } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { deleteBerthById } from "../../services";
import toast from "react-hot-toast";
import CardMedia from "@mui/material/CardMedia";
import defaultBlogImage from "../../assets/default-blog.png";
import CardContent from "@mui/material/CardContent";
import dayjs from "dayjs";
import { useUser } from "../../contexts/UserContext";

export const BerthCard = ({ type, data, token, deleteBerth, editBerth }) => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL;
  const { profileComplete, isStripeAccountVerified, loadingUserData } = useUser()
  // console.log("card data: ", data);
  const {
    berthSpecifications: { beam, length, dockHeight, depth },
    currentLocation: { name: location },
    availableFor,
    power,
    portEmail,
    name,
    id,
    chargesPerDay,
    chargesPerMonth,
    fixedTotalPrice,
    berthImagePath,
    availableDate,
  } = data;

  // console.log("ddd: ", availableDate);

  let displayRate = null;
  let displayRateType = null;

  if (chargesPerDay) {
    displayRate = chargesPerDay;
    displayRateType = " per day";
  } else if (chargesPerMonth) {
    displayRate = chargesPerMonth;
    displayRateType = " per month";
  } else if (fixedTotalPrice) {
    displayRate = fixedTotalPrice;
    displayRateType = " fixed";
  }

  const handleNavigate = () => {
    if (type === "request" || type === "own_request") {
      navigate("berth-detail", {
        state: { type, data },
      });
      return;
    }

    if (
      type === "result" && 
      profileComplete && 
      isStripeAccountVerified && 
      !loadingUserData
    ) {
      navigate("/home/cart", {
        state: { data },
      });
    } else if (
      type === "result" && 
      !profileComplete && 
      !loadingUserData
    ) {
      toast.error("Please complete your profile first");
      navigate("/home/profile");
    } else if (
      type === "result" && 
      !isStripeAccountVerified && 
      !loadingUserData
    ) {
      toast.error("Please connect your Stripe account first");
      navigate("/home/payment-account");
    }

    return;
  };

  const handleDelete = async () => {
    const res = await deleteBerthById(id, token);

    if (res?.status === true) {
      toast.success("Berth deleted successfully");
      deleteBerth(data?.id);
      return;
    }

    if (res?.status === false) {
      if (res?.message === "Invalid or expired access token.") {
        toast.error("Token expired, please re-login and try");
        return;
      }

      toast.error("Something went wrong please try later");
      return;
    }

    toast.error("Something went wrong please try later");
    return;
  };

  const handleEdit = async () => {
    editBerth(data);
    return;
  };

  // console.log("data: ", data);

  return (
    <Card className="BearthCard" onClick={handleNavigate}>
      <CardMedia
        component="img"
        alt="berth-image"
        // height="100"
        sx={{ height: "160px", borderRadius: "2px" }}
        image={
          berthImagePath ? `${baseUrl}${berthImagePath}` : defaultBlogImage
        }
      />
      <CardContent style={{ paddingBottom: "16px" }}>
        <div className="bearth-details-container">
          <div className="bearth-content-row">
            <div className="title-data">
              <Typography className="bearth-title" variant="h4" component="h4">
                {name ? name : "--"}
              </Typography>
            </div>
            <div className="type-data">
              <div
                className={`cardTypeBox ${
                  availableFor
                    ? availableFor === "hire or swap"
                      ? "hireOrSwap"
                      : availableFor
                    : "hireOrSwap"
                }`}
              >
                Open to {availableFor ? availableFor : "--"}
              </div>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="left-data">
              <p>€ {displayRate ? displayRate : "--"}{displayRateType}</p>
            </div>
            <div className="right-data">
              <p>{location ? location : "--"}</p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="left-data">
              <p>
                Length: <strong>{length ? length : "--"}m</strong>
              </p>
            </div>
            <div className="right-data">
              <p>
                Beam: <strong>{beam ? beam : "--"}m</strong>
              </p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="left-data">
              <p>
                Depth: <strong>{depth ? depth : "--"}m</strong>
              </p>
            </div>
            <div className="right-data">
              <p>
                Dock height: <strong>{dockHeight ? dockHeight : "--"}m</strong>
              </p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="left-data">
              {type === "own" ? (
                <p>
                  Availability:{" "}
                  {availableDate
                    ? dayjs(availableDate[0]?.startDate).format("YYYY-MM-DD")
                    : "--"}{" "}
                  to{" "}
                  {availableDate
                    ? dayjs(availableDate[0]?.endDate).format("YYYY-MM-DD")
                    : "--"}
                </p>
              ) : (
                <p>
                  Availability:{" "}
                  {availableDate
                    ? dayjs(availableDate[0]?.startDate).format("YYYY-MM-DD")
                    : "--"}{" "}
                  to{" "}
                  {availableDate
                    ? dayjs(
                        availableDate[availableDate.length - 1]?.endDate
                      ).format("YYYY-MM-DD")
                    : "--"}
                </p>
              )}
            </div>
            <div className="right-data">
              {type === "own" && (
                <>
                  <IconButton aria-label="edit" onClick={handleEdit}>
                    <ModeEditIcon fontSize="small" />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={handleDelete}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
